
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'umi';
import { getUaSelect } from '../../services/dashboard';
import {listFetchInterceptor} from "@/pages/dashboard/_config/filterListMap";
import { formatSortFiltersData } from '@/pages/dashboard/utils/_config/formatSortFiltersData';
import { useSelectorMap } from '../../utils/customHook';
import { getMediaChannelIcon, mediaChannelMap } from '@/pages/home/_config/mediaChannal';
import Default from '@/pages/home/assets/svg/dashboard/default.svg';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';

export const useFilterData = () => {
  const [loading, setLoading] = useState(true); // 筛选器loading
  const {getUaSelectorText} = useSelectorMap();
  const dispatch = useDispatch()
  const { currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame
    }
  });

  const selectorRef = useRef<any>({
    gameCode: currentGame?.game_code
  });

  const  handleFilterList = (list,type, id,name_en,name_ch ) => {
    let filterList: any = []
    list?.forEach(item => {
      filterList.push({
        // ua 的平台筛选器以及channel传英文名称
        [id]:item?.[name_en],
        // 和后端沟通后（松坚），如果英文名称是空，则都替换为others
        [name_en]: getUaSelectorText(type, item?.[name_en]=== '' ? 'Others' : item?.[name_en]),
        [name_ch]: getUaSelectorText(type, item?.[name_en]=== '' ? '其他' : item?.[name_ch]),
      })
    })
    return filterList || []
  }

  // 获取页面ua页selector
  const getSelectorInfo = (gameCode: string): void => {
    getUaSelect({
      game_code: gameCode
    }).then(data => {
      // 当前只要求ua的平台和渠道筛选器做次处理；
      data.os_list = handleFilterList(data?.os_list,'system','os_id', 'os_name_en','os_name_ch',);
      data.channel_list = handleFilterList(data?.channel_list,'channel', 'channel_id','channel_name_en','channel_name_ch')
      if (data?.os_list) {
        data.os_list = data.os_list.map((item: any) => {
          const cleanedEnKey = (item.os_name_en || '').toLowerCase().replace(/\s+/g, '');
          item.icon = getSystemFlag(cleanedEnKey) || Default;
          return item;
        });
      }
      if (data?.ua_network) {
        data.ua_network = data.ua_network.map((item: any) => {
          const channelIcon = getMediaChannelIcon(item.name_en || item.code || '');
          item.icon = channelIcon === mediaChannelMap._default ? Default : channelIcon;
          return item;
        });
      }
      if (data?.channel_list) {
        data.channel_list = data.channel_list.map((item: any) => {
          const channelIcon = getMediaChannelIcon(item.channel_name_en || item.channel_id || '');
          item.icon = channelIcon === mediaChannelMap._default ? Default : channelIcon;
          return item;
        });
      }
      const dataResult = formatSortFiltersData(data || {})
      selectorRef.current = {
        ...dataResult,
        gameCode,
        latestDate:{
            date:data?.last_date?.daily_date || moment().format('YYYY-MM-DD'),
            hour:data?.last_date?.hour_date|| moment().format('YYYY-MM-DD'),
            week:data?.last_date?.weekly_date|| moment().format('YYYY-MM-DD'),
            month:data?.last_date?.monthly_date|| moment().format('YYYY-MM-DD'),
        }
      }
      listFetchInterceptor(gameCode, data)
      dispatch({
        type: 'dashboardSetting/getUaSelectorMap',
        payload: {
          uaSelector:data,
          gameCode:gameCode
        },
      });
    }).catch(e=>{
      console.log(e)
    }).finally(() => {
      setLoading(false);
    });
  };

  // 初始化
  useEffect(() => {
    if (currentGame?.game_code) {
      getSelectorInfo(currentGame.game_code);
    }
  }, [currentGame]);

  return {
    loading,
    selector: selectorRef.current
  }
}
